// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__12v5C","startButton":"styles_startButton__VWEp7"};